module.exports = __webpack_public_path__ + "img/02010401.cd3bf762.png";